
define('AwaLabs.SalesCategories', [
    'Facets.Model',
    'SC.Configuration',
    'underscore',
    'AvoidCategories',
    'Profile.Model'
], function AwaLabsSalesCategories(
    FacetsModel,
    Configuration,
    _,
    AvoidCategories,
    ProfileModel
) {
    'use strict';

    return {
        mountToApp: function mountToApp() {
            // get the configuration urls for on sale categories
            var onSaleCategories = Configuration.get('salesCategories.config');

            _.extend(FacetsModel.prototype, {
                fetch: _.wrap(FacetsModel.prototype.fetch, function wrap(fn) {
                    // -------------------------------------------------------------------------------------------------
                    // Section: Modify the url for the on sale categories
                    // -------------------------------------------------------------------------------------------------
                    var categoryCoincidence;
                    var storeFacetValue;
                    var commerceCategory = this.options.data.commercecategoryurl;
                    var store;
                    var storeName;
                    // remove the (/) char
                    commerceCategory = commerceCategory && commerceCategory.slice(1);

                    categoryCoincidence = _.find(onSaleCategories, function filter(element) {
                        return element.saleCategoryUrl === commerceCategory;
                    });

                    if (categoryCoincidence) {
                        // get the store name or id used to send as a facet
                        // TODO:CodeReview probably we need to use the translator here to get the correct facet depending on the id of the store
                        // Since we are working on a low level, this is the fetch of facet model, the translator was built and used before.
                        store = ProfileModel.getInstance().get('store');
                        storeName = store ? store.get('name') : undefined;

                        if (storeName) {
                            // convert to the expected facet value
                            storeFacetValue = storeName.replace(/\s/g, '-');
                            this.options.data.commercecategoryurl = '/' + categoryCoincidence.baseCategoryUrl;
                            // filter by the facet
                            this.options.data.custitem_awa_onsale_in_store = storeFacetValue;
                        }
                    }
                    // -------------------------------------------------------------------------------------------------

                    // call the base function
                    return fn.apply(this, _.toArray(arguments).slice(1));
                })
            });
        }
    };
});
